import { bindMethod } from 'helpers/bind';
import Component from 'navigation/component/Component';
import mqStore from 'store/mqStore';
class ProductBar extends Component {
    _visible = false;
    get visible() {
        return this._visible;
    }
    set visible(value) {
        if (value === this._visible)
            return;
        this._visible = value;
        this.refs.productBar.parentElement.classList.toggle('hidden', !value);
    }
    initialized() {
        super.initialized();
        this.onSwitchMq(mqStore.tabletPortrait.get());
    }
    bindEvents(add = true) {
        const method = bindMethod(add);
        mqStore.tabletPortrait.toggleListener(add, this.onSwitchMq);
        window[method]('sizebay:rendered', this.refresh.bind(this));
        this?.refs?.infosToggle?.[method]('click', this.onInfosToggleClick);
    }
    onInfosToggleClick = (e) => {
        e.preventDefault();
        window.dispatchEvent(new Event('size-guide:open-mobile'));
    };
    onSwitchMq = (isTabletPortrait) => {
        if (isTabletPortrait)
            this.visible = true;
        else
            this.visible = false;
    };
    resize() {
        super.resize();
    }
}
export default ProductBar;
